import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/http/auth.service';
import { map, take } from 'rxjs/operators';

/**
 * This service checks if a user has access to a route. Access rules are defined in {@link AppRoutingModule}.
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);


  /**
   * Takes the latest user value and checks if a user has required authorities to access a route. It either allows to activate a route, or
   * redirects to a different route.
   * @param route activated route.
   */
  canActivate(route: ActivatedRouteSnapshot) {
    return this.authService.user.pipe(
      take(1),
      map(user => {
        const isAuth = !!user;
        if (isAuth) {
          if (route.data.roles && !user.authorities.some(authority => route.data.roles.includes(authority))) {
            this.router.navigate(['/']);
            return false;
          }
          return true;
        } else {
          return this.router.createUrlTree(['/login']);
        }
      }));
  }
}
